import { createBasicSelector } from 'util/redux'
import { emptyObj } from 'util/objects'
import { selectBase } from './selectBase'

export const selectTemplates = createBasicSelector(
  selectBase,
  base => base.templates || emptyObj
)
